exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nlabel[data-v-7d7505f6] {\n  font-weight: 600;\n  color: black;\n}\nth[data-v-7d7505f6] {\n  font-size: 13px;\n  font-family: Roboto;\n}\ntd[data-v-7d7505f6] {\n  font-size: 12px;\n  font-family: Roboto;\n}\n.mx-datepicker[data-v-7d7505f6] {\n  width: 251px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7d7505f6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./src/views/components/reports/goodsReceiptReport/goodsReceiptReport.component.scss
// module id = 1435
// module chunks = 0